import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useAuth } from '../lib/auth'

/**
 * Workspace dashboard. Visually mirrors the original `section` blocks —
 * dark navy card on the dark page bg, mono eyebrow + Inter title +
 * subtle lede + tile grid.
 */
export function Dashboard() {
  const { t } = useTranslation()
  const { user } = useAuth()

  return (
    <section className="section active" data-section="dashboard">
      <div className="section-head">
        <div className="section-num">
          00<span className="dot">.</span>
        </div>
        <div className="section-title-block">
          <div className="label">Workspace · Overview</div>
          <h2>{t('dashboard.welcome')}</h2>
          <p className="subtitle">{t('dashboard.subtitle')}</p>
        </div>
      </div>

      <div className="dash-tiles">
        <Link to="/briefs" className="dash-tile">
          <div className="dash-tile__label">{t('briefs.title')}</div>
          <div className="dash-tile__hint">
            {t('briefs.subtitle', 'Tu cartera de intakes — abre uno para ver revisiones, preparación y entregables.')}
          </div>
        </Link>

        <Link to="/intake/new" className="dash-tile dash-tile--accent">
          <div className="dash-tile__label">{t('dashboard.new_brief')}</div>
          <div className="dash-tile__hint">
            {t('intake.subtitle')}
          </div>
        </Link>

        {user && (
          <div className="dash-tile dash-tile--meta">
            <div className="dash-tile__label">Sesión</div>
            <div className="dash-tile__mono">{user.email ?? user.sub}</div>
            <div className="dash-tile__hint">{user.roles.join(' · ') || '—'}</div>
          </div>
        )}
      </div>
    </section>
  )
}
